import { render } from "./MaterialsSlideType.vue?vue&type=template&id=604a927b"
import script from "./MaterialsSlideType.vue?vue&type=script&lang=js"
export * from "./MaterialsSlideType.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nigomatulin/projects/WOPA/tverstroyka/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__